import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyService } from 'app/services/models/company.service';
import { ProductService } from 'app/services/models/product.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import * as moment from 'moment';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TaxService } from 'app/services/models/tax.service';
import { CurrencyService } from 'app/services/models/currency.service';
import { TransactionProductService } from 'app/services/models/transaction-product.service';
import { TransactionService } from 'app/services/models/transaction.service';
import { TransactionProductCreate } from 'app/dtos/TransactionProduct/CreateTransactionProduct';
import { ToastrService } from 'ngx-toastr';
import { WarehouseService } from 'app/services/models/warehouse.service';
import { TransactionAdditionalFeatureService } from 'app/services/models/transaction-additional-feature.service';
import { ProductVariantService } from 'app/services/models/product-variant.service';

@Component({
  selector: 'app-transaction-create-dilaog',
  templateUrl: './transaction-create-dilaog.component.html',
  styleUrls: ['./transaction-create-dilaog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TransactionCreateDilaogComponent implements OnInit {
  @Input() data: {
    tempId?: any, message: string; product: any; discountRate: number; transactionId?: number, kindId?: number, selectedWarehouseId?: number; currencyId?: number
  };
  isSerialProduct: boolean = false;
  serialNumbers: string[] = [];
  saleSeriNo: number[] = [];

  constructor(
    public ngbModal: NgbActiveModal,
    private productService: ProductService,
    private taxService: TaxService,
    private currencyService: CurrencyService,
    private modalService: NgbModal,
    private transactionProductService: TransactionProductService,
    private transactionService: TransactionService,
    private toastrService: ToastrService,
    private warehouseService: WarehouseService,
    private transactionFeatureService: TransactionAdditionalFeatureService,
    private productVariantService: ProductVariantService) { }

  allTax: any[] = [];
  currencies: any[] = [];
  product: any = {};

  allVariants: any[] = [];

  count = 1;
  description: string;
  discountRate: number = 0;
  total: number = 0;
  warehouses: any[] = [];
  selectedWarehouseId: number;
  selectedCurrencyId: number;

  purchasePrice: number = 0;

  public priceDifferencePercentage: number = 0;

  features: any[] = [];
  selectedFeatures: any[] = [];

  async ngOnInit() {
    console.log(this.data);
    this.discountRate = this.data?.discountRate ?? 0;
    await this.getAllTax();
    await this.getAllCurrency();
    await this.getAllWarehouse();
    if (this.data.tempId == null)
      await this.getByIdProduct(this.data.product);
    else {
      this.product = this.data.product
      this.selectedWarehouseId = this.data.selectedWarehouseId;
      this.purchasePrice = this.data.product?.purchasePrice ?? 0;
      this.selectedCurrencyId = Number(this.data.currencyId) ?? this.currencies[0].id;
      this.product.saleTaxId = this.product?.saleTaxId ?? this.allTax[0].id;
      this.product.saleTax = this.product.saleTax ?? this.allTax[0].taxRate;
      this.calculateTotalPrice();
      this.calculatePriceDifferencePercentage();
    }
    await this.getAllTransactionFeatures();
  }

  async getAllTransactionFeatures() {
    const data = await this.transactionFeatureService.getAllTransactionAdditionalFeatures(0, 1000, null);
    console.log(data);
    this.features = data.transactionAdditionals.map(feature => ({
      ...feature,
      value: feature.value ?? this.product.typeName !== 'Diğer' ? true : null // Eğer değer yoksa varsayılan olarak false ata
    }));
  }

  updateSelectedFeatures() {
    // Seçili veya seçili değil tüm özellikleri ekle
    if (this.product?.typeName === 'Diğer') {
      this.selectedFeatures = null;
      console.log('Ürün tipi "Diğer" olduğu için özellikler temizlendi.');
      return;
    }
    this.selectedFeatures = this.features.map(feature => ({
      id: feature.id,
      name: feature.name,
      value: feature.value == true ? true : false
    }));
    console.log('Updated Selected Features:', this.selectedFeatures);
  }

  toggleSerialInput(): void {
    if (this.isSerialProduct && this.data?.kindId == 6) {
      console.log(this.saleSeriNo);
      this.count = 0;
      this.saleSeriNo = [];
    } else if (this.isSerialProduct && this.data.kindId == 5) {
      this.updateSerialInputs();
    }
    else {
      this.saleSeriNo = [];
      this.serialNumbers = []; // Checkbox kapatıldığında seri numaralarını temizle
    }
  }

  // Adet değişimini kontrol eden metot
  // checkSerialInput(): void {
  //   if (this.isSerialProduct) {
  //     this.updateSerialInputs();
  //   }
  // }

  // get salePriceValue(): number {
  //   return this.product?.salePrice ?? this.data?.product?.salePrice;
  // }

  preventFocusLoss(index: number): void {
    const element = document.getElementById(`serial-${index}`) as HTMLInputElement;
    if (element) {
      element.focus();
    }
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }

  private updateSerialInputs(): void {
    if (this.isSerialProduct && this.count > 0) {
      const currentLength = this.serialNumbers.length;

      // Eğer count mevcut sayıdan büyükse, eksik sayıda input ekle
      if (this.count > currentLength) {
        for (let i = currentLength; i < this.count; i++) {
          this.serialNumbers.push('');
        }
      }

      // Eğer count mevcut sayıdan küçükse, fazlalık inputları sil
      if (this.count < currentLength) {
        this.serialNumbers.splice(this.count);
      }
    } else {
      this.serialNumbers = []; // Checkbox kapalıysa veya count 0'sa temizle
    }
  }

  isAllSerialNumbersFilled(): boolean {
    if (this.data.kindId === 5) {
      if (this.isSerialProduct && this.serialNumbers.length > 0) {
        return this.serialNumbers.every(serial => serial.trim() !== '');
      }
      return true;
    } else {
      return false;
    }
  }

  updateSelectedSerials(seri: any): void {
    if (this.saleSeriNo.includes(seri.id)) {
      // Checkbox işareti kaldırıldığında ID'yi çıkar
      const index = this.saleSeriNo.indexOf(seri.id);
      if (index > -1) {
        this.saleSeriNo.splice(index, 1);
      }
    } else {
      // Checkbox seçildiğinde ID'yi ekle
      this.saleSeriNo.push(seri.id);
    }

    this.count = this.saleSeriNo.length;

    if (!this.isSerialProduct) {
      this.saleSeriNo = []; // Seri numarası kapalıysa listeyi sıfırla
    }

    this.calculateTotalPrice();
    this.allFieldsFilled();
    console.log('Seçilen Seri Numaraları:', this.saleSeriNo);
  }


  async getAllWarehouse() {
    const data = await this.warehouseService.getAllWarehouses(0, 100, '');
    this.warehouses = data.warehouses;
    console.log(this.warehouses);
  }

  getProductCountDifference(warehouseId: number): number {
    const productCount = this.product.transactionProductsCount?.find(pc => pc.warehouseId === warehouseId);
    return productCount ? productCount.totalProductCountDifference : 0;
  }

  async getByIdProduct(product) {
    const data = await this.productService.getByIdProduct(product.id);
    this.product = data;
    console.log(this.product);
    this.selectedWarehouseId = this.warehouses[0].id;
    this.purchasePrice = this.product?.purchasePrice ?? 0;
    this.selectedCurrencyId = this.product?.currencyId ?? this.currencies[0].id;
    this.product.saleTaxId = this.product?.saleTaxId ?? this.allTax[0].id;
    this.product.saleTax = this.product.saleTax ?? this.allTax[0].taxRate;
    this.calculateTotalPrice();
    this.calculatePriceDifferencePercentage();
    await this.getByIdProductVariants(this.product.id);
  }

  async getByIdProductVariants(id) {
    const data = await this.productVariantService.getByIdProductVariants(id);
    console.log(data);
    // this.allVariants = data;
    this.allVariants = data.map(v => ({
      ...v,
      variantType: v.variantType, // burada backend’den gelen typeId varsa onu kullan
      selectedOptionId: null,
      valueText: '',
      valueBool: false,
      displayType: 2 // 1 = görünmesin, 2 = colonda, 3 = ürün adının yanında (default 2)
    }));
    console.log(this.allVariants);
    this.checkRequiredVariantsFilled();
  }

  requiredVariantsFilled = true;

  checkRequiredVariantsFilled() {
    // isRequired = true olan varyantlar kontrol edilir
    this.requiredVariantsFilled = this.allVariants.every(v => {
      if (!v.isRequired) return true;

      // select
      if (v.variantType === 1) return v.selectedOptionId != null && v.selectedOptionId !== '';

      // checkbox
      if (v.variantType === 2) return v.valueBool === true || v.valueBool === false; // checkbox her zaman dolu sayılabilir, ama istersen true şartı koyabilirsin

      // input
      if (v.variantType === 3) return v.valueText && v.valueText.trim() !== '';

      return true;
    });
  }

  prepareTransactionProductVariants() {
    const variantsDto = this.allVariants.map(v => ({
      transactionProductId: 0,
      productVariantId: v.id,
      valueText: v.variantType === 3 ? v.valueText : null,
      productVariantOptionId:
        v.variantType === 1 ? v.selectedOptionId != null ? Number(v.selectedOptionId) : null : null,
      valueBool: v.variantType === 2 ? v.valueBool : null,
      displayColonOrName: v.displayType,
      variant:v
    }));

    console.log("Gönderilecek Variant DTO listesi:", variantsDto);
    return variantsDto;
  }

  calculatePriceDifferencePercentage(): void {
    const purchasePrice = this.purchasePrice || 0; // Ensure this is correctly bound to the purchase price
    const salePrice = parseFloat(this.product.salePrice) || 0; // This binds to the sale price input

    if (purchasePrice > 0) { // Prevent division by zero
      this.priceDifferencePercentage = ((salePrice - purchasePrice) / purchasePrice) * 100;
    } else {
      this.priceDifferencePercentage = 0; // Reset if purchase price is 0
    }
  }

  resetForm() {
    this.product = {};
    this.count = 1;
    this.description = '';
    this.discountRate = 0;
    this.total = 0;
    this.selectedWarehouseId = null;
    this.purchasePrice = 0;
    this.selectedWarehouseId = null;
    this.selectedFeatures = null;
  }

  onWarehouseChange(event: any) {
    this.selectedWarehouseId = event.target.value;
    console.log("Seçilen Depo ID:", this.selectedWarehouseId);
  }

  onCurrencySelect(event: any) {
    const selectedValue = event.target.value; // Seçilen değeri almak için
    console.log("Seçilen para:", selectedValue);
    this.selectedCurrencyId = selectedValue;
  }


  async calculateTotalPrice() {
    const salePrice = this.product.salePrice || 0;
    const discount = this.discountRate || 0;
    const tax = this.allTax.find((tax) => tax.id === this.product.saleTaxId)?.taxRate || 0;

    const discountedPrice = salePrice - (salePrice * discount) / 100;
    const totalWithTax = discountedPrice + (discountedPrice * tax) / 100;

    this.total = parseFloat((this.count * totalWithTax).toFixed(4));

  }

  async calculateSalePriceFromTotal() {
    const discount = this.discountRate || 0;
    const tax = this.allTax.find((tax) => tax.id === this.product.saleTaxId)?.taxRate || 0;

    const totalWithoutTax = this.total / (1 + tax / 100);
    const salePrice = totalWithoutTax / (1 - discount / 100);

    this.product.salePrice = (salePrice / this.count).toFixed(4);
    console.log("Satış fiyatı : ", this.product.salePrice);
  }

  async getAllTax() {
    const data = await this.taxService.getAllTax(0, 100, '');
    console.log(data);
    this.allTax = data.taxex;
  }

  async getAllCurrency() {
    const data = await this.currencyService.getAllPageCurrency(0, 100, '');
    console.log(data);
    this.currencies = data.currenies;
  }

  onSaleTaxChange(event: any) {
    console.log(event.target.value);
    const selectedTax = this.allTax.find(tax => tax.id === Number(event.target.value));
    console.log(selectedTax);
    if (selectedTax) {
      this.product.saleTaxId = selectedTax.id
      this.product.saleTax = selectedTax.taxRate;
    } else {
      this.product.saleTax = null; // Handle case where no tax is selected
    }
    this.calculateTotalPrice();
  }

  async addTransactionProduct() {
    this.updateSelectedFeatures();
    const transactionProduct: TransactionProductCreate = {
      currencyId: this.selectedCurrencyId,
      description: this.description,
      discountRate: this.discountRate,
      productCount: this.count,
      productId: this.product.id, // Ürün ID'sini kullanın
      productPrice: this.product.salePrice, // Satış fiyatı
      taxId: this.product.saleTaxId, // Vergi ID'si
      transactionId: this.data?.transactionId, // İşlem ID'si
      warehouseId: this.selectedWarehouseId, // Depo ID'si,
      seriNos: this.serialNumbers,
      saleSerialNos: this.saleSeriNo,
      createTransactionProductVariantDtos : this.prepareTransactionProductVariants(),
      createTransactionAdditionalFeatureMatching: Array.isArray(this.selectedFeatures)
        ? this.selectedFeatures.map(feature => ({
          transactionAdditionalFeatureId: feature.id,
          value: feature.value
        }))
        : []
    };

    console.log(transactionProduct);
    const response = await this.transactionProductService.transactionProductCreate(transactionProduct);
    if (response.status == true) {
      this.toastrService.success(response.message);
      this.transactionService.sendEvent(true);
      this.closeModal();
    }

  }

  addTransaction() {
    //daha önce oluşmayan teklif detayına ürün eklemek için kullanılacak
    this.updateSelectedFeatures();
    let tempId = null;
    if (this.data.tempId) {
      tempId = this.data.tempId;
    } else {
      tempId = this.data.tempId ?? Math.random().toString(36).substr(2, 9);
    }

    const transactionData = {
      product: this.product,
      count: this.count,
      selectedWarehouseId: this.selectedWarehouseId,
      salePrice: this.product.salePrice,
      saleTax: this.product.saleTax,
      saleTaxId: this.product.saleTaxId,
      discountRate: this.discountRate,
      total: this.total,
      currencyId: this.selectedCurrencyId,
      description: this.description,
      seriNos: this.serialNumbers,
      saleSerialNos: this.saleSeriNo,
      selectedFeatures: this.selectedFeatures,
      tempId: tempId,
      productVariants: this.prepareTransactionProductVariants()
    };

    this.ngbModal.close(transactionData);

    this.resetForm();
  }

  allFieldsFilled(): boolean {
    return this.count != null && this.count > 0 &&
      this.selectedWarehouseId != null &&
      this.product?.salePrice != null &&
      this.product?.saleTaxId != null &&
      this.discountRate != null && this.discountRate >= 0 &&
      this.total != null &&
      this.selectedCurrencyId != null;
  }

  closeModal() {
    this.ngbModal.close();
  }

}
